import React, {Component} from 'react';
import {Modal, Steps, Button} from 'antd';
import $ from 'jquery';
import {uuid} from "../utils";
import './stepPopupBoxstyle.css';
import {Scrollbars} from "react-custom-scrollbars";

const {Step} = Steps;

/**
 * 带有上一步，下一步按钮的弹出框
 */
class StepPopupBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: props.current,
            visible: props.visible,
            nextBtnLoad:false,
            key:"stepPopupBox_",
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            visible: nextProps.visible,
            current: nextProps.current,
            key:"stepPopupBox_",
        });
    }

    previouStep() {
        this.state.current--;
        this.props.onChange(this.state.current);
        $(".content_item").hide();
        $(".content_item").eq(this.state.current).show();
        this.setState({});
    }

    nextStep() {
        // this.setState({
        //     nextBtnLoad:true
        // });

        window.loading.show();
        window.setTimeout(()=>{
            let currentComponent = this.props.stepDataSource[this.state.current];
            let saveOkFlag = currentComponent.content.props.saveData();
            if (saveOkFlag) {
                this.state.current++;
                this.props.onChange(this.state.current);
                $(".content_item").hide();
                $(".content_item").eq(this.state.current).show();
            }

            window.loading.hide();
            // this.setState({
            //     nextBtnLoad:false
            // });
        }, 50);
    }

    handleCancel() {
        this.props.closeModel();
    }

    continueCreate() {
        let currentComponent = this.props.stepDataSource[this.state.current];
        currentComponent.content.props.saveData();
        this.props.getTaskStatus()
        this.setState({
            current: 0,
            key:"stepPopupBox_",
        });
        $(".content_item").hide();
        $(".content_item").eq(0).show();
    }

    render() {
        let bottomButton = [<Button className={"previous_step"} key={uuid()} onClick={() => {
            this.previouStep()
        }}>
            上一步
        </Button>,
            <Button className={"next_step"} key={uuid()} type="primary" loading={this.state.nextBtnLoad} onClick={() => {
                this.nextStep()
            }}>
                下一步
            </Button>];
        if (this.state.current == 0) {
            bottomButton = [<Button key={uuid()} onClick={() => {
                this.handleCancel()
            }}>
                取消
            </Button>,
                <Button className={"next_step"} key={uuid()} type="primary" loading={this.state.nextBtnLoad} onClick={() => {
                    this.nextStep()
                }}>
                    下一步
                </Button>]
        } else if (this.state.current == this.props.stepDataSource.length - 1) {
            bottomButton = [<Button key={uuid()} type="primary" className={"next_step"} onClick={() => {
                this.continueCreate()
            }}>
                继续创建
            </Button>,
                <Button key={uuid()}  onClick={()=>this.handleCancel()}>
                    关闭
                </Button>]
        }

        //计算小三角箭头的位置。
        let triangleLeft = (this.state.current / this.props.stepDataSource.length) == 0 ? 0.06 : (this.state.current / (this.props.stepDataSource.length - 1));
        triangleLeft = triangleLeft * 100;
        if(this.state.current==2||this.state.current==3){
            triangleLeft=triangleLeft-this.state.current*3;
        }

        return <Modal
            onCancel={this.handleCancel.bind(this)}
            title={this.props.title}
            visible={this.state.visible}
            footer={[
               bottomButton
            ]}
            keyboard={false}
            maskClosable={false}
            centered={true}
            width={'65%'}
            className={'step_popup_modal'}
        >
            <div className={'step_popup_container'} key={this.state.key}>
                <div className={"step_popup_head"}>
                    <Steps current={this.state.current}>
                        {
                            this.props.stepDataSource.map((item, index) => {
                                if (index <= this.state.current) {
                                    return <Step key={index} title={item.title} icon={<div className={"img_background"}
                                                                                            style={{backgroundColor: '#ffc168'}}>
                                        <img style={{marginTop: '11px'}} src={item.img}/></div>}/>
                                } else {
                                    return <Step key={index} title={item.title}
                                                 icon={<div className={"img_background"}><img
                                                     style={{marginTop: '11px'}}
                                                     src={item.img}/></div>}/>
                                }
                            })
                        }
                    </Steps>
                </div>
                <div className={'step_index_line'}>
                    <div className={"step_index_triangle"} style={{left: triangleLeft + '%'}}></div>
                </div>
                <div className={"step_content"}>
                    <Scrollbars>
                    {
                        this.props.stepDataSource.map((item, index) => {
                            return <div className={"content_item"} key={item.key?item.key:index} style={{display:(index===this.state.current ? "block":"none")}}>
                                {item.content}
                            </div>
                        })}
                    </Scrollbars>
                </div>
            </div>
        </Modal>
    }
}
StepPopupBox.defaultProps={
    current:0,
    onChange:()=>{}
};
export default StepPopupBox;